import { loginAxios } from "./config/axiosConfig";

export interface AdminLoginPayload {
  email: string;
  password: string;
}

export interface AdminLoginResponse {
  userDetails: {
    firstName: string;
    lastName: string;
    email: string;
    designation: string;
    roleIds: {
      id: string;
      roleName: string;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
    };
  };
  accessToken: string;
}

export const adminLogin = async (
  payload: AdminLoginPayload
): Promise<{
  success: boolean;
  data?: AdminLoginResponse;
  message?: string;
}> => {
  try {
    const response = await loginAxios.post<{
      success: boolean;
      data: AdminLoginResponse;
    }>("/admin/login", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return {
      success: response.data.success,
      data: response.data.data,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.data || "Login failed",
    };
  }
};
